module.exports = __webpack_public_path__ + "static/img/0541_3.ab7e7a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_3.jpg
// module id = VtF5
// module chunks = 1